import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Design-system keyboard key. Single source for `<kbd>` styling. `light`
 * (default) sits on light surfaces; `dark` on dark overlays (e.g. selection).
 */
export function Kbd({ children, variant = 'light', className }: { children: ReactNode; variant?: 'light' | 'dark'; className?: string }) {
  return (
    <kbd className={cn('px-2 py-1 rounded text-xs font-medium', variant === 'dark' ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-500', className)}>
      {children}
    </kbd>
  );
}
